<template>
  <div>
    <div class="card-title-wrap">
      <h5>交付进程</h5>
      <span class="car-tag pc" v-if="orderDetail.estimatedDeliveryDate">
        {{ orderDetail.estimatedDeliveryDate }}
      </span>
    </div>
    <div class="order-shop-wrap">
      <h5 class="order-shop">{{ orderDetail.offlineExperienceShopName }}</h5>
      <p class="order-shop-address">{{ orderDetail.addr }}</p>
      <div
        class="order-shop-phone-wrap"
        v-if="orderDetail.plannerData && orderDetail.plannerData.phone"
      >
        <img
          src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud%2FbackendUpload%2F20230713114046080-icon_phone.png"
          alt=""
        />
        <span>{{
          orderDetail.plannerData ? orderDetail.plannerData.phone : "-"
        }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "orderShop",
  components: {},
  props: {
    orderDetail: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss">
@import "@style/base";
@import "@style/common";
* {
  margin: 0;
}
.order-shop-wrap {
  padding: 15px 12px;
  border-radius: 8px;
  border: 1px solid #eee;
  margin-bottom: 30px;
  .order-shop {
    color: #000;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
  }
  .order-shop-address {
    color: #4c4f59;
    font-size: 14px;
  }
  .order-shop-phone-wrap {
    display: flex;
    padding-top: 20px;
    span {
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px;
      color: #00b9ef;
    }
    img {
      width: 20px;
    }
  }
}
.card-title-wrap {
  @include media(
    (
      $home-lg: (),
      $home-bg: (),
      $home-md: (
        margin: 40px 0 20px,
      ),
      $home-sm: (
        margin: 40px 0 20px,
      ),
    )
  );

  h5 {
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 25px;
    letter-spacing: 0.5px;
    color: #000;
  }
  .car-tag {
    font-size: 12px;
    font-weight: 500;
    line-height: 19px;
    color: #00b9ef;
    padding: 2px 15px;
    border-radius: 62px;
    background: #e6f8fd;
    // display: block;
    @include media(
      (
        $home-lg: (
          margin: 10px 0 40px,
        ),
        $home-bg: (
          margin: 10px 0 40px,
        ),
        $home-md: (),
        $home-sm: (),
      )
    );
  }
}
</style>
